import i18next from 'i18next';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useConfig } from '../../providers/Config';
import { ProfileProvider } from '../../providers/Profile';
import { lazyWithRetry } from '../../utils/lazyWithRetry';

const Landing = lazyWithRetry(() => import('../../pages/Landing'));
const SignUpPage = lazyWithRetry(() => import('../../pages/SignUp'));
const SignInPage = lazyWithRetry(() => import('../../pages/SignIn'));
const ResetPassword = lazyWithRetry(() => import('../../pages/ResetPassword'));
const NewPassword = lazyWithRetry(() => import('../../pages/NewPassword'));
const DynamicError = lazyWithRetry(() => import('../../pages/Error/Dynamic'));
const Confirmation = lazyWithRetry(() => import('../../pages/EmailVerification/Confirmation'));
const Activate = lazyWithRetry(() => import('../../pages/EmailVerification/Activate'));
const Activated = lazyWithRetry(() => import('../../pages/EmailVerification/Activated'));
const Privacy = lazyWithRetry(() => import('../../pages/Privacy'));
const Terms = lazyWithRetry(() => import('../../pages/Terms'));
const Guest = lazyWithRetry(() => import('../../pages/Guest'));
const OnSite = lazyWithRetry(() => import('../../pages/OnSite'));

const PublicRouter: React.FC = () => {
  const { featureFlags } = useConfig();
  const { disableRegistration, enableRegistrationWithToken } = featureFlags || {};

  return (
    <Switch>
      <Route
        path="/"
        exact={true}
        render={() => {
          if (disableRegistration || enableRegistrationWithToken) return <SignInPage />;
          return <Landing />;
        }}
      />
      <Route path="/sign-in" exact={true} render={() => <SignInPage />} />
      <Route path="/sign-up" exact={true} render={() => <SignUpPage />} />
      <Route
        path="/404"
        exact={true}
        render={() => (
          <ProfileProvider>
            <DynamicError errTitle="404" />
          </ProfileProvider>
        )}
      />
      <Route
        path="/500"
        exact={true}
        render={() => (
          <ProfileProvider>
            <DynamicError
              errTitle="500"
              errMsg={`${i18next.t('ns.error_page:500:subtitle')}`}
              errMetaTitle={`${i18next.t('ns.error_page:500:page_title')}`}
              errLinkText={`${i18next.t('ns.error_page:500:link_text')}`}
            />
          </ProfileProvider>
        )}
      />
      <Route path="/activate" exact={true} render={() => <Activate />} />
      <Route path="/activated" exact={true} render={() => <Activated />} />
      <Route path="/confirmation" render={() => <Confirmation />} />
      <Route path="/reset-password" render={() => <ResetPassword />} />
      <Route path="/new-password" render={() => <NewPassword />} />
      <Route path="/privacy" render={() => <Privacy />} />
      <Route path="/terms" render={() => <Terms />} />
      <Route path="/guest/:context?" render={() => <Guest />} />
      <Route path="/onsite/:assetUID" render={() => <OnSite />} />
      <Redirect from="*" to="/404" />
    </Switch>
  );
};

export default PublicRouter;
